'use client';

import { useRef } from 'react';
import SearchInputField from './search-input-field';
import SearchResults from './search-results';
import { useSearchModal } from './context/search-modal-context';
import { useSearchQuery } from './utils/use-search-query';
import { useSearchResults } from './utils/use-search-results';
import { useSearchSubmit } from './utils/use-search-submit';
const SearchDesktop = () => {
  const {
    query,
    setQuery
  } = useSearchQuery();
  const {
    isOpen,
    open,
    close
  } = useSearchModal();
  const {
    results,
    noResult,
    isFetching,
    isError
  } = useSearchResults(query, isOpen);
  const inputRef = useRef<HTMLInputElement>(null);
  const handleSubmit = useSearchSubmit({
    query,
    setQuery,
    onSubmit: () => inputRef.current?.blur()
  });
  return <div className='relative mx-auto hidden w-full max-w-xl grow lg:flex lg:flex-col' data-sentry-component="SearchDesktop" data-sentry-source-file="search-desktop.tsx">
            <form className='relative z-[103] flex w-full' autoComplete='off' data-test='search-form' toolname='search' tooldescription='Search for products, categories, and brands' onSubmit={handleSubmit}>
                <SearchInputField ref={inputRef} query={query} setQuery={setQuery} isFetching={isFetching} onFocus={open} className='w-full' inputClassName='border-border-gray-medium focus:border-pink-200 lg:min-w-[520px] lg:text-body-16' data-sentry-element="SearchInputField" data-sentry-source-file="search-desktop.tsx" />
            </form>

            {isOpen && <>
                    <div className='fixed inset-0 z-[102] bg-gray-900 opacity-40' role='button' onClick={() => close()} />

                    <div data-test='search-result' className='absolute right-0 top-full z-[103] mt-1 max-h-[70vh] w-full overflow-y-auto rounded border border-border-gray-medium bg-white px-2 py-3 shadow-md'>
                        <div className='relative w-full leading-4'>
                            <SearchResults isFetching={isFetching} query={query} noResult={noResult} isError={isError} results={results} isOpen={isOpen} variant='desktop' />
                        </div>
                    </div>
                </>}
        </div>;
};
export default SearchDesktop;